import React from "react"
import { HomeAccordionWrapper } from "./HomeAccordion.styles"
import ArrowDown from "../../../icons/phosphor/regular/ArrowDown"
import ArrowRight from "../../../icons/phosphor/regular/ArrowRight"
import { graphql, useStaticQuery } from "gatsby"
import { StatamicHtml } from "../../../utils/statamicAssets"

/**
 * @returns {{
 *   faqsTitle: string | null,
 *   faqs: {
 *     title: string,
 *     copy: string
 *   }[]
 * }|null}
 */
function useAccordionItems(){
  const query = useStaticQuery(graphql`
    query HomeAccordionQuery {
      statamic {
        entries(collection: "home", limit: 1) {
          data {
            ... on Statamic_Entry_Home_Home {
              faqs_title
              faqs {
                title
                copy {
                  ... on Statamic_BardText {
                    text
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const node = query?.statamic?.entries?.data?.[0]
  if(!node) return null
  if(!node.faqs?.length) return null

  return {
    faqsTitle: node.faqs_title || null,
    faqs: node.faqs.map(faq => ({
      title: faq.title,
      copy: typeof faq.copy === "string"
        ? faq.copy
        : (faq.copy || []).map(block => (block && block.text) || "").join(""),
    })),
  }
}

export default function HomeAccordion(){

  const accordion = useAccordionItems()
  if(!accordion) return null

  return (
      <HomeAccordionWrapper className="px-3">
        <div className="container">
          <div className="intro">
            {accordion.faqsTitle && <h2>{accordion.faqsTitle}</h2>}

            <div className="buttons">
              <a href="/contact-us" className="btn">Request a demo</a>
              <a href="/payment-orchestration-platform/" className="btn ghost">
                See how it works
                <ArrowRight />
              </a>
            </div>
          </div>

          <div className="accordion-container">
            {accordion.faqs.map((faq, index) => (
                <details key={index} name="home-accordion">
                  <summary>
                    {faq.title}
                    <ArrowDown />
                  </summary>
                  <StatamicHtml as="div" className="contents" html={faq.copy} />
                </details>
            ))}
          </div>

        </div>
      </HomeAccordionWrapper>
  )
}
